export const CALENDAR_FILTER_OPTIONS = {
    all: {
        name: 'All',
        value: 'all'
    },
    order: {
        name: 'Orders',
        value: 'order'
    },
    delivery: {
        name: 'Deliveries',
        value: 'delivery'
    },
    installation: {
        name: 'Installation',
        value: 'installation'
    },
    leave: {
        name: 'Leave',
        value: 'leave'
    },
}
